import { Grid } from "@mui/material";

interface Props {
  HoursElement: JSX.Element;
  DescriptionElement: JSX.Element;
}

const WorkLogHoursWrapper = ({ HoursElement, DescriptionElement }: Props) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={3}>
        {HoursElement}
      </Grid>

      <Grid item xs={9}>
        {DescriptionElement}
      </Grid>
    </Grid>
  );
};

export default WorkLogHoursWrapper;
